<div class="cards content" fxLayout="row" fxLayoutAlign="start start">
  @if (!dataCards.length) {
    <div class="empty">{{ 'generic.nothing_to_display' | translate }}</div>
  }
  @for (dataCard of dataCards; track dataCard) {
    <div class="p-16" fxFlex="auto" fxFlex.gt-xs="50" fxFlex.gt-lg="33" >
      <app-card [dataCard]="dataCard" [ngClass]="lessonsConfigurationService.getCardLayout()" fxFlex></app-card>
    </div>
  }
</div>
